// apps/web/src/layouts/components/SidebarCompetitorOfferBadge.tsx
//
// Badge do Álamo Cobre (Validações e cobertura > Álamo Cobre): solicitações de
// cobertura de oferta aguardando decisão do analista. O número vem de
// `useSidebarBadgeCounts()`, montado uma vez no topo da sidebar admin.

import { useTranslation } from 'react-i18next';

import { SidebarCountBadge, type SidebarCountBadgeVariant } from './SidebarCountBadge';

export interface SidebarCompetitorOfferBadgeProps {
  count: number;
  variant?: SidebarCountBadgeVariant;
}

export function SidebarCompetitorOfferBadge({ count, variant }: SidebarCompetitorOfferBadgeProps) {
  const { t } = useTranslation('competitor_offer');
  return (
    <SidebarCountBadge
      count={count}
      variant={variant}
      testId="sidebar-competitor-offer-badge"
      label={t('admin.sidebar.badge_aria', { count })}
    />
  );
}
